import { FetchResult } from '@apollo/client'
import {
  useMarkAsReadMutation,
  IMarkAsReadMutationVariables,
  IMarkAsReadMutation,
} from '../graphql/MarkAsRead'

export const useMarkAsRead = () => {
  const [_markAsRead, state] = useMarkAsReadMutation()

  /**
   * Update the notification's `readAt` property
   */
  const markAsRead = async (id: IMarkAsReadMutationVariables['id']) => {
    let response: FetchResult<IMarkAsReadMutation> | null = null

    try {
      response = await _markAsRead({
        variables: {
          id,
        },
      })
    } catch (e) {
      // no op
    }

    return response
  }

  return {
    ...state,
    markAsRead,
  }
}
